<template>
  <div class="history-time-line">
      <div class="time-line-item" v-for="(item,itemIndex) in timeLineData" :key="itemIndex">
        <div class="item-time">
          {{item.createTime.substring(5)}}
        </div>
        <div class="item-dividing-line">
          <div class="circle"></div>
          <div class="line"  v-if="itemIndex+1 !== timeLineData.length"></div>
        </div>
        <div class="item-content">
          <div v-if="item.content.split(' ').length === 3">
            <span>{{item.content.split(' ')[0]}}</span>
            <span style="color: #5AD3CD;">{{' '+item.content.split(' ')[1]+' '}}</span>
            <span>{{item.content.split(' ')[2]}}</span>
          </div>
          <div v-else>
            {{item.content}}
          </div>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name: 'HistoryTimeLine',
  props: {
    value: {
      type: Array,
      default: ()=>[]
    }
  },
  data() {
    return {
      timeLineData: []
    }
  },
  mounted() {
    console.log('value = ',this.value)
    this.timeLineData = this.value
  }
}
</script>
<style lang="scss">
.history-time-line{
  max-height: 500px;
  padding-right: 36px;
  overflow-y: auto;
  padding-left: 36px;
  .time-line-item{
    display: flex;
    margin-bottom: 10px;
    .item-time{
      width: 135px;
      //flex: 0 0 200px;
      font-family: PingFang HK, PingFang HK;
      font-weight: 400;
      font-size: 18px;
      color: #999999;
      text-align: right;
    }
    .item-dividing-line{
      margin: 0 24px;
      .circle{
        width: 8px;
        height: 8px;
        background-color: #5AD3CD;
        border-radius: 50%;
        margin-top: 9px;
        margin-bottom: 16px;
      }
      .line{
        width: 5px;
        height: 32px;
        border-right: 2px solid #5AD3CD;
        opacity: 0.3;
      }
    }
    .item-content{
      //width: 232px;
      flex: 1;
      font-family: PingFang HK, PingFang HK;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
    }
  }
}
</style>
